import instance from "../store/actions/instance";

const memory = new Map();
const clean = value => String(value || "").slice(0, 12000)
  .replace(/([?&#])[^\s)]+/g, "$1[redacted]")
  .replace(/[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/g, "[email]")
  .replace(/\beyJ[\w.-]+/g, "[token]")
  .replace(/\+?\d[\d ()-]{7,}\d/g, "[number]");

export const buildFrontendErrorReport = (error, info = {}, props = {}, recovery = {}) => {
  const settings = props.store?.settings || {};
  const cart = props.main_cart || {};
  const context = {
    schema: 1,
    name: clean(error?.name),
    message: clean(error?.message || error),
    stack: clean(error?.stack),
    componentStack: clean(info?.componentStack),
    recovery,
    storeLoaded: Boolean(props.store),
    storeId: props.store?.id,
    merchandisingV2: settings.storefront_merchandising_v2,
    checkoutV2: settings.storefront_checkout_v2,
    branchBased: settings.is_branch_based_ordering,
    branchSelected: Boolean(props.branch?.branch),
    productId: props.current_product?.id,
    cartLines: Array.isArray(cart.cart) ? cart.cart.length : null,
    promoLines: Array.isArray(cart.promo_items) ? cart.promo_items.length : null,
    online: navigator.onLine,
    // Hashed bundle filenames identify the deployed build without new settings.
    bundles: Array.from(document.scripts).map(s => s.src)
      .filter(src => /\/static\/js\//.test(src))
      .map(src => src.split("/").pop().split("?")[0]).slice(0, 12),
  };
  return {
    error: clean(`${error?.name || "Error"}: ${error?.message || error}`),
    info: JSON.stringify(context),
    browser: navigator.userAgent,
    path: window.location.pathname.replace(/\/(track|checkout)\/[^/]+/g, "/$1/[redacted]"),
  };
};

export const reportFrontendError = async (payload, capture) => {
  // One fixed-size key per browser; reserve before network I/O to prevent races.
  const key = "frontendErrorReportV1";
  const now = Date.now();
  let previous = memory.get(key) || 0;
  try { previous = Math.max(previous, Number(localStorage.getItem(key)) || 0); } catch (_) {}
  if (previous && now - previous < 30000) return false;
  memory.set(key, now);
  try { localStorage.setItem(key, String(now)); } catch (_) {}
  try { if (capture) capture(); } catch (_) {}
  try {
    await instance.post("send_error/", payload, { timeout: 2500 });
  } catch (_) {
    // Reporting failure must never throw into the error boundary itself.
  }
  return true;
};
